import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { filter } from 'lodash';
const getIsAllSelected = selectedItems => {
  const selectedItemsValues = Object.values(selectedItems);
  if (selectedItemsValues.length === 0) {
    return false;
  }
  return selectedItemsValues.every(item => item === true);
};
function getInitialState(items) {
  const keys = {};
  items.forEach(item => {
    keys[item._id] = false;
  });
  return keys;
}
function getAllSelected(items) {
  const keys = {};
  items.forEach(item => {
    keys[item._id] = true;
  });
  return keys;
}
const handleAll = (isAllSelected, setSelectedItems, data) => {
  if (isAllSelected) {
    setSelectedItems(getInitialState(data));
    return null;
  }
  setSelectedItems(getAllSelected(data));
  return null;
};
function useTableCheckboxes({
  data,
  withCheckbox
}) {
  const [selectedItems, setSelectedItems] = React.useState({});
  const filteredData = React.useMemo(() => {
    const isFunction = withCheckbox instanceof Function;
    if (isFunction) {
      return filter(data, withCheckbox);
    }
    return data;
  }, [data, withCheckbox]);
  const isAllSelected = getIsAllSelected(selectedItems);
  React.useEffect(() => {
    setSelectedItems(getInitialState(filteredData));
  }, [filteredData]);
  const handleSelectItem = React.useCallback(id => {
    setSelectedItems(prevState => _extends({}, prevState, {
      [id]: !prevState[id]
    }));
  }, [setSelectedItems]);
  const clearSelectedItems = React.useCallback(() => {
    setSelectedItems(getInitialState(filteredData));
  }, [filteredData]);
  const getTitleCheckboxProps = React.useCallback(() => ({
    checked: !!isAllSelected,
    onChange: () => handleAll(isAllSelected, setSelectedItems, filteredData),
    indeterminate: !isAllSelected && Object.values(selectedItems).some(it => it === true)
  }), [isAllSelected, selectedItems, filteredData]);
  const getCheckboxProps = React.useCallback(value => ({
    checked: !!selectedItems[value],
    onChange: () => handleSelectItem(value)
  }), [selectedItems, handleSelectItem]);
  const values = React.useMemo(() => ({
    selectedItems,
    setSelectedItems,
    getTitleCheckboxProps,
    getCheckboxProps,
    clearSelectedItems
  }), [selectedItems, getTitleCheckboxProps, getCheckboxProps, clearSelectedItems]);
  return values;
}
export default useTableCheckboxes;